import * as angular from 'angular';
import { IRequestService } from '../request.service';
import { ITrigger, TriggerType } from '../../models';

export interface ItriggerService {
    getAll(): angular.IPromise<ITrigger[]>;
    getAll(force: boolean): angular.IPromise<ITrigger[]>;
    getByGuid(guid: string): angular.IPromise<ITrigger>;
    getByGuid(guid: string, force: boolean): angular.IPromise<ITrigger>;
    addOne(trigger: ITrigger): angular.IPromise<ITrigger>;
    updateOne(trigger: ITrigger): angular.IPromise<ITrigger>;
    deleteOne(guid: String): angular.IPromise<ITrigger>;
}

export class TriggerService implements ItriggerService {
    static serviceId = 'triggerService';
    private _controllerUrl = 'trigger';

    static $inject = ['requestService'];
    constructor(private _requestService: IRequestService) {
    }

    getAll(): angular.IPromise<ITrigger[]>;
    getAll(force: boolean): angular.IPromise<ITrigger[]>;
    getAll(force?: boolean): angular.IPromise<ITrigger[]> {
        if (force) {
            this._requestService.cleanCacheAtV1(this._controllerUrl);
        }
        return this._requestService.getAtV1(this._controllerUrl);
    }

    getByGuid(guid: string): angular.IPromise<ITrigger>;
    getByGuid(guid: string, force: boolean): angular.IPromise<ITrigger>;
    getByGuid(guid: string, force?: boolean): angular.IPromise<ITrigger> {
        const url = `${this._controllerUrl}/${guid}`;
        if (force) {
            this._requestService.cleanCacheAtV1(url);
        }
        return this._requestService.getAtV1(url);
    }

    addOne(trigger: ITrigger): angular.IPromise<ITrigger> {
        return this._requestService.postAtV1<ITrigger>(`${this._controllerUrl}/add${TriggerType[trigger.type]}`, trigger)
            .then(data => {
                this._requestService.cleanCacheAtV1(this._controllerUrl);
                return data;
            });
    }
    updateOne(trigger: ITrigger): angular.IPromise<ITrigger> {
        return this._requestService.postAtV1<ITrigger>(`${this._controllerUrl}/update${TriggerType[trigger.type]}`, trigger)
            .then(data => {
                this._requestService.cleanCacheAtV1(this._controllerUrl);
                return data;
            });
    }

    deleteOne(guid: String): angular.IPromise<ITrigger> {
        return this._requestService.postAtV1<ITrigger>(`${this._controllerUrl}/delete/${guid}`)
            .then(data => {
                this._requestService.cleanCacheAtV1(this._controllerUrl);
                return data;
            });
    }
}